<template>
    <v-flex xs12 sm12 md4>

        <v-card style="background-color: transparent !important" width="100%">
            <v-card flat class="text-xs-center ma-3">
                <v-card-title class=" primary">
                    <span class="card-title-text" style="color: white; font-size:small"><v-icon size="14" color="white">
                            mdi-account </v-icon> ASEGURADO</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-form ref="form" v-model="validForm" lazy-validation>

                    <v-card-text>
                        <v-col md="12">


                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Delitos</h4>
                            <v-row>
                                <v-col cols="6" sm="4" md="4">
                                    <v-checkbox v-model="datos.Svdpa" :class="classdisabled" label="Daños"
                                        style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.Svlesiones" :class="classdisabled" label="Lesiones"
                                        style="margin: 0px" @change="datos.lclave = null" hide-details></v-checkbox>
                                    <v-radio-group v-model="datos.lclave" :error-messages="validation.errorLesiones"
                                        :class="classdisabled" v-if="datos.Svlesiones"
                                        style="margin: -1px; margin-left: 15px;">
                                        <v-radio label="Ambulatorias" value="1"></v-radio>
                                        <v-radio label="Hospitalización" value="2"></v-radio>
                                    </v-radio-group>

                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    <v-checkbox v-model="datos.Svrobo" :class="classdisabled" label="Robo"
                                        style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.Svhomicidios" :class="classdisabled" label="Homicidio"
                                        style="margin: 0px" hide-details></v-checkbox>
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    <v-checkbox v-model="datos.Svavgc" :class="classdisabled" label="AVGC"
                                        style="margin: 0px" hide-details></v-checkbox>
                                </v-col>

                            </v-row>
                        </v-col>
                        <div v-if="validation.errorDelitos">
                            <span class='spanError' style="color:red;font-size:12px">Indique al menos una opción</span>
                            <br />
                        </div>
                        <v-col md="12">


                            <h6 class="text-info" style="color: #2196f3;">Agravantes</h6>
                            <v-row>
                                <v-col>
                                    <v-checkbox v-model="datos.Svebriedad" :class="classdisabled"
                                        label="Estado de ebriedad" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.Svfuga" :class="classdisabled"
                                        label="Abandono de víctima / fuga" style="margin: 0px"
                                        hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.Svdrogas" :class="classdisabled"
                                        label="Drogas o estupefacientes" style="margin: 0px" hide-details></v-checkbox>
                                </v-col>

                            </v-row>
                        </v-col>

                        <v-col md="12">
                            <!--<v-btn @click="prueba()"> Limpiar</v-btn>-->

                            <h6 class="text-info" style="color: #2196f3; ">Tipo Accidente</h6>
                            <v-row>
                                <v-col>
                                    <span v-if="editAsegurado && !isAccidentSelected" style="color: red; font-size: 12px;">
                                        Indique al menos una opción
                                    </span>

                                    <v-checkbox v-model="datos.Svcortedc" :class="classdisabled"
                                                label="Corte de circulación" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.Svpreferenciadp" :class="classdisabled"
                                                label="Preferencia de paso (crucero o intersección)" style="margin: 0px"
                                                hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.Svpasadada" :class="classdisabled"
                                                @change="cambioPasada()" label="Pasada de alto" style="margin: 0px"
                                                hide-details></v-checkbox>
                                    <v-col v-if="datos.Svpasadada">
                                        <strong>Cruce con:</strong>
                                        <multiselect v-model="datos.pdaclave"
                                                     deselect-label="No se puede remover el valor seleccionado" :disabled="edit"
                                                     selected-label="Seleccionado" select-label="Seleccione Cruce con"
                                                     track-by="pdaclave" label="pdamotivo" placeholder="Seleccione una opción"
                                                     :options="opcionesPasadaAlto" :allow-empty="false">
                                        </multiselect>
                                        <!--validacion-->
                                        <div v-if="validation.errorCrucecon">
                                            <span class='spanError' style="color:red;font-size:12px">
                                                Indique una
                                                opción
                                            </span>
                                            <br />
                                        </div>
                                        <strong>Testigos:</strong>
                                        <v-radio-group row v-model="datos.pdatestigos"
                                                       :error-messages="validation.errorTestigos" @change="cambioTestigos()" inline
                                                       :class="classdisabled" style="margin: -1px; margin-left: 15px;">
                                            <v-radio label="Sí" value="1"></v-radio>
                                            <v-radio label="No" value="0"></v-radio>
                                        </v-radio-group>

                                        <v-row v-if="datos.pdatestigos == '1'">
                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.pdatestigosocupante" :class="classdisabled"
                                                            label="Ocupantes" style="margin: 0px" hide-details></v-checkbox>
                                            </v-col>
                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.pdatestigosexterno" :class="classdisabled"
                                                            label="Externos" style="margin: 0px" hide-details></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <!--validacion-->
                                        <div v-if="validation.errorTestigosExtra">
                                            <span class='spanError' style="color:red;font-size:12px">
                                                Indique una
                                                opción
                                            </span>
                                            <br />
                                        </div>

                                        <strong>Cámaras:</strong>
                                        <v-radio-group row v-model="datos.pdacamaras"
                                                       :error-messages="validation.errorCamaras" @change="cambioCamaras()" inline
                                                       :class="classdisabled" style="margin: -1px; margin-left: 15px;">
                                            <v-radio label="Sí" value="1"></v-radio>
                                            <v-radio label="No" value="0"></v-radio>
                                        </v-radio-group>
                                        <v-row v-if="datos.pdacamaras == '1'">
                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.pdacamarastransito" :class="classdisabled"
                                                            label="Transito" style="margin: 0px" hide-details></v-checkbox>
                                            </v-col>
                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.pdacamarasparticular" :class="classdisabled"
                                                            label="Particulares" style="margin: 0px" hide-details></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <!--validacion-->
                                        <div v-if="validation.errorCamarasExtra">
                                            <span class='spanError' style="color:red;font-size:12px">
                                                Indique una
                                                opción
                                            </span>
                                            <br />
                                        </div>

                                    </v-col>
                                    <v-checkbox v-model="datos.Svperdidadc" :class="classdisabled"
                                                label="Pérdida de control" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.Svinvanciondc" :class="classdisabled"
                                                label="Invasión de carril" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.Saincorp" :class="classdisabled" label="Incorporación"
                                                style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.Svalcancecp" :class="classdisabled"
                                                label="Alcance con proyección" style="margin: 0px" hide-details></v-checkbox>

                                    <v-checkbox v-model="datos.Svalcances" :class="classdisabled" label="Alcance simple"
                                                style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.Svalcancepa" :class="classdisabled"
                                                label="Alcance por alcance" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.Svmaniobrasdr" :class="classdisabled"
                                                label="Maniobras de reversa" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.Svatropello" :class="classdisabled" label="Atropello"
                                                style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.Svotrata" :class="classdisabled" label="Otro"
                                                style="margin: 0px" hide-details></v-checkbox>
                                    <!--<v-textarea @input="uppercase('Svotrotaobs')"
    v-on:blur="datos.Svotrotaobs = datos.Svotrotaobs != null ? datos.Svotrotaobs.trim() : null"
    :counter="$store.state.maxLengthComentarios" :rules="rulestextareaOtro" outlined
    rows="2" :disabled="editObs" :maxlength="$store.state.maxLengthComentarios"
    :filled="editObs" v-model="datos.Svotrotaobs"></v-textarea>-->
                                    <v-textarea @input="uppercase('Svotrotaobs')"
                                        v-on:blur="datos.Svotrotaobs = datos.Svotrotaobs != null ? datos.Svotrotaobs.trim() : null"
                                        :counter="255" :rules="rulestextareaOtro" outlined rows="2" :disabled="editObs"
                                        maxlength="255" :filled="editObs" v-model="datos.Svotrotaobs"></v-textarea>

                                </v-col>

                            </v-row>
                        </v-col>

                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">
                                Responsabilidad por parte de
                            </h4>
                            <p>De conformidad al criterio del ajustador, el responsable es:</p>

                            <v-row>
                                <v-col md="12">
                                    <v-radio-group v-model="datos.Svresponsable" :class="classdisabled"
                                                   :error-messages="validation.errorResponsabilidad">
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-radio label="Asegurado" value="NA"></v-radio>
                                                <v-radio label="Corresponsabilidad" value="CO"></v-radio>
                                                <v-radio label="Tercero" value="TR"></v-radio>

                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-radio label="Golpe Fuga" value="GF"></v-radio>
                                                <v-radio label="No se puede determinar" value="ND"></v-radio>

                                            </v-col>
                                        </v-row>
                                    </v-radio-group>
                                </v-col>

                            </v-row>
                            <br />
                            <!--<v-textarea @input="uppercase('Svdetporque')"
                            v-on:blur="datos.Svdetporque = datos.Svdetporque != null ? datos.Svdetporque.trim() : null"
                            :counter="$store.state.maxLengthComentarios" :rules="rulestextareaDet" outlined rows="2"
                            :disabled="editPorque" :maxlength="$store.state.maxLengthComentarios"
                            :filled="editPorque" v-model="datos.Svdetporque"></v-textarea>-->
                            <v-textarea @input="uppercase('Svdetporque')"
                                v-on:blur="datos.Svdetporque = datos.Svdetporque != null ? datos.Svdetporque.trim() : null"
                                :counter="255" :rules="rulestextareaDet" outlined rows="2" :disabled="editPorque"
                                maxlength="255" :filled="editPorque" v-model="datos.Svdetporque"></v-textarea>

                        </v-col>

                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-text>
                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">
                                Datos proporcionados por el
                                ajustador (obligatorio)
                            </h4>
                            <v-checkbox v-model="datos.Svcondicionado" :class="classdisabled"
                                label="El siniestro quedó condicionado" style="margin: 0px" hide-details></v-checkbox>

                            <!--<v-textarea @input="uppercase('Svcondporque')"
                                v-on:blur="datos.Svcondporque = datos.Svcondporque != null ? datos.Svcondporque.trim() : null"
                                :counter="255" :rules="rulestextareaCond" outlined rows="2" :disabled="editCond"
                                maxlength="255" :filled="editCond" v-model="datos.Svcondporque"></v-textarea>
                            <span style="font-weight: bold;">Marca:</span>
                            <v-text-field v-model="datos.Svmarca"
                                v-on:blur="datos.Svmarca = datos.Svmarca != null ? datos.Svmarca.trim() : null" outlined
                                dense :rules="rulesInputs(1, 20)" disabled filled></v-text-field>
                            <span style="font-weight: bold;">Color:</span>
                            <v-text-field v-model="datos.Svcolor"
                                v-on:blur="datos.Svcolor = datos.Svcolor != null ? datos.Svcolor.trim() : null" outlined
                                dense :rules="rulesInputs(1, 15)" disabled filled></v-text-field>
                            <span style="font-weight: bold;">No.Licencia:</span>
                            <v-text-field v-model="datos.Svlicencia"
                                v-on:blur="datos.Svlicencia = datos.Svlicencia != null ? datos.Svlicencia.trim() : null"
                                outlined dense :error-messages="validation.errorLicencia" :rules="rulesInputs(3, 16)"
                                :disabled="edit" :filled="edit"></v-text-field>
                            <span style="font-weight: bold;">Modelo:</span>
                            <v-text-field v-model="datos.Svmodelo"
                                v-on:blur="datos.Svmodelo = datos.Svmodelo != null ? datos.Svmodelo.trim() : null"
                                outlined dense :rules="rulesInputs(1, 30)" disabled filled></v-text-field>
                            <span style="font-weight: bold;">Placas:</span>
                            <v-text-field v-model="datos.Svplaca"
                                v-on:blur="datos.Svplaca = datos.Svplaca != null ? datos.Svplaca.trim() : null" outlined
                                dense :error-messages="validation.errorPlaca" :rules="rulesInputs(3, 15)"
                                :disabled="edit" :filled="edit"></v-text-field>
                            <!--<br />-->
                            <span style="font-weight: bold;">Monto de daños del vehículo asegurado:</span>

                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <span style="font-weight: bold;">Monto del deducible:</span>
                                    <v-text-field v-model="datos.Svdeducible" outlined dense :rules="rulesInputsNumber"
                                        @keypress="ruleMoney($event, datos.Svdeducible)" :disabled="edit"
                                        :filled="edit"></v-text-field>
                                    <span style="font-weight: bold;">Pérdida total:</span>
                                    <v-text-field v-model="datos.Svperdidatotal" outlined dense
                                        :rules="rulesInputsNumber" @keypress="ruleMoney($event, datos.Svperdidatotal)"
                                        :disabled="edit" :filled="edit"></v-text-field>
                                    <span style="font-weight: bold;">Estimado de daños:</span>
                                    <v-text-field v-model="datos.Svestdanosveh" outlined dense
                                        :rules="rulesInputsNumberDanios" :error-messages="validation.errorEstDanos"
                                        @keypress="ruleMoneyDanios($event, datos.Svestdanosveh)" :disabled="edit"
                                        :filled="edit"></v-text-field>

                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <span style="font-weight: bold;">Tipo de Cobertura:</span>
                                    <multiselect v-model="datos.dacobertura" deselect-label="No se puede remover"
                                        :disabled="edit" selected-label="Seleccionado"
                                        select-label="Seleccione Cobertura" track-by="dacobertura" label="text"
                                        placeholder="" :options="opcionesCobertura" :allow-empty="false">
                                    </multiselect>
                                    <!--validacion-->
                                    <div v-if="validation.errorCobertura">
                                        <span class='spanError' style="color:red;font-size:12px">
                                            Seleccione el tipo de
                                            cobertura
                                        </span>
                                    </div>
                                    <br />
                                    <v-checkbox v-model="datos.Svrevisapoliza" label="Póliza Revisada"
                                        :class="classdisabled" :error-messages="validation.errorPoliza"
                                        style="margin: 0px"></v-checkbox>
                                    <br />
                                    <v-btn v-if="!showbuttons && !disabledbutton" class="ma-2" color="primary"
                                        @click="enabledForm()" :disabled="disabledbutton">
                                        <span style='color: white;'>Editar</span>
                                    </v-btn>

                                    <v-btn v-if="showbuttons && !disabledbutton" class="ma-2" color="primary"
                                        @click="guardarEdicion()" :disabled="disabledSave">
                                        <span style='color: white;'>Guardar</span>
                                    </v-btn>


                                    <v-btn v-if="editAsegurado" class="ma-2" color="#FF4081" @click="cancelar()"
                                        :disabled="disabledSave">
                                        <span style='color: white;'>Cancelar</span>
                                    </v-btn>



                                </v-col>

                            </v-row>


                        </v-col>

                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-text>
                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">
                                Responsabilidad por parte del
                                lider
                            </h4>
                            <v-row>
                                <v-col md="12">
                                    <v-radio-group v-model="datos.sacriteriolider" class="disable-action">
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-radio label="Asegurado" value="NA"></v-radio>
                                                <v-radio label="Corresponsabilidad" value="CO"></v-radio>
                                                <v-radio label="Tercero" value="TR"></v-radio>

                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-radio label="Golpe Fuga" value="GF"></v-radio>
                                                <v-radio label="No se puede determinar" value="ND"></v-radio>

                                            </v-col>
                                        </v-row>
                                    </v-radio-group>
                                </v-col>

                            </v-row>


                            <!--<v-textarea @input="uppercase('sadesclider')"
                            v-on:blur="datos.sadesclider = datos.sadesclider != null ? datos.sadesclider.trim() : null"
                            :counter="$store.state.maxLengthComentarios" :rules="rulestextarea" outlined rows="2"
                            disabled filled :maxlength="$store.state.maxLengthComentarios"
                            v-model="datos.sadesclider"></v-textarea>-->

                            <v-textarea @input="uppercase('sadesclider')"
                                v-on:blur="datos.sadesclider = datos.sadesclider != null ? datos.sadesclider.trim() : null"
                                :counter="255" :rules="rulestextarea" outlined rows="2"
                                disabled filled maxlength="255"
                                v-model="datos.sadesclider"></v-textarea>

                        </v-col>

                    </v-card-text>


                    <v-divider></v-divider>
                    <v-card-text>

                        <v-col md="12">


                            <v-row>
                                <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Autoridad Competente
                                </h4>
                                <v-spacer></v-spacer>
                                <v-btn v-if="classAutoridad != '' && validatermino" @click="editarAutoridad()" icon>
                                    <v-icon color="blue">mdi-lead-pencil</v-icon>
                                </v-btn>

                                <v-btn v-if="classAutoridad == ''" @click="guardarAutoridad()" icon>
                                    <v-icon color="blue">mdi-content-save</v-icon>
                                </v-btn>
                                <v-btn v-if="classAutoridad == ''" @click="cancelarAutoridad()" icon>
                                    <v-icon color="blue">mdi-keyboard-return</v-icon>
                                </v-btn>
                            </v-row>

                            <v-row>
                                <v-col>
                                    <v-radio-group v-model="datos.saautoridad" :class="classAutoridad">
                                        <v-radio label="Tránsito" value="TR"></v-radio>
                                        <v-radio label="Guardia Nacional" value="GN"></v-radio>
                                        <v-radio label="Ministerio Público" value="MP"></v-radio>
                                        <v-radio label="Juez Cívico" value="JC"></v-radio>
                                        <v-radio label="Sin autoridad" value="SA"></v-radio>
                                    </v-radio-group>

                                </v-col>

                            </v-row>

                        </v-col>


                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-text>
                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Personalidad del conductor
                            </h4>

                            <v-row>
                                <v-col>
                                    <v-radio-group v-model="datos.Paclave" class="disable-action">
                                        <v-radio label="Tranquilo" value="1"></v-radio>
                                        <v-radio label="Medianamente complejo" value="2"></v-radio>
                                        <v-radio label="Complejo" value="3"></v-radio>
                                        <v-radio label="Muy complejo" value="4"></v-radio>

                                    </v-radio-group>

                                </v-col>

                            </v-row>

                        </v-col>

                    </v-card-text>



                    <v-col v-if="datos.datHomicidios">
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-col md="12">
                                <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Datos de homicidio</h4>

                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <h4 class="text-info" style="color: #2196f3; font-size: 15px; ">NA</h4>
                                        <v-btn-toggle v-if="datos.dhnaocupante">
                                            <v-btn x-small class="disable-action" color="success">
                                                SI
                                            </v-btn>
                                            <v-btn x-small class="disable-action">
                                                NO
                                            </v-btn>
                                        </v-btn-toggle>
                                        <v-btn-toggle v-if="!datos.dhnaocupante">
                                            <v-btn x-small class="disable-action">
                                                SI
                                            </v-btn>
                                            <v-btn x-small class="disable-action" color="success">
                                                NO
                                            </v-btn>
                                        </v-btn-toggle>
                                        <br />
                                        <span>Ocupante</span>
                                        <br />
                                        <span v-if="datos.dhnaocupantenum > 0">Cantidad: {{ datos.dhnaocupantenum
                                            }}</span>


                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <h4 class="text-info" style="color: #2196f3; font-size: 15px; ">Tercero</h4>
                                        <v-btn-toggle v-if="datos.dh3conductor">
                                            <v-btn x-small class="disable-action" color="success">
                                                SI
                                            </v-btn>
                                            <v-btn x-small class="disable-action">
                                                NO
                                            </v-btn>
                                        </v-btn-toggle>
                                        <v-btn-toggle v-if="!datos.dh3conductor">
                                            <v-btn x-small class="disable-action">
                                                SI
                                            </v-btn>
                                            <v-btn x-small class="disable-action" color="success">
                                                NO
                                            </v-btn>
                                        </v-btn-toggle>
                                        <br />
                                        <span>Conductor</span>
                                        <br />
                                        <div v-if="datos.dh3conductornum > 0">
                                            <span v-if="datos.dh3conductornum > 0">
                                                Cantidad:
                                                {{ datos.dh3conductornum }}
                                            </span>
                                            <br />
                                        </div>



                                        <v-btn-toggle class="mt-2" v-if="datos.dh3ocupante">
                                            <v-btn x-small class="disable-action" color="success">
                                                SI
                                            </v-btn>
                                            <v-btn x-small class="disable-action">
                                                NO
                                            </v-btn>
                                        </v-btn-toggle>
                                        <v-btn-toggle class="mt-2" v-if="!datos.dh3ocupante">
                                            <v-btn x-small class="disable-action">
                                                SI
                                            </v-btn>
                                            <v-btn x-small class="disable-action" color="success">
                                                NO
                                            </v-btn>
                                        </v-btn-toggle>
                                        <br />
                                        <span>Ocupante</span>
                                        <br />
                                        <div v-if="datos.dh3ocupantenum > 0">
                                            <span v-if="datos.dh3ocupantenum > 0">Cantidad: {{ datos.dh3ocupantenum
                                                }}</span>
                                            <br />
                                        </div>



                                        <v-btn-toggle class="mt-2" v-if="datos.dh3peaton">
                                            <v-btn x-small class="disable-action" color="success">
                                                SI
                                            </v-btn>
                                            <v-btn x-small class="disable-action">
                                                NO
                                            </v-btn>
                                        </v-btn-toggle>
                                        <v-btn-toggle class="mt-2" v-if="!datos.dh3peaton">
                                            <v-btn x-small class="disable-action">
                                                SI
                                            </v-btn>
                                            <v-btn x-small class="disable-action" color="success">
                                                NO
                                            </v-btn>
                                        </v-btn-toggle>

                                        <br />
                                        <span>Peatón</span>
                                        <br />
                                        <span v-if="datos.dh3peatonnum > 0">Cantidad: {{ datos.dh3peatonnum }}</span>

                                    </v-col>

                                </v-row>

                            </v-col>

                        </v-card-text>
                    </v-col>


                    <v-divider></v-divider>
                    <v-card-text>
                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">
                                En caso de haber
                                ocupantes/pasajeros con lesiones/homicidio, captúrelos aquí:
                            </h4>

                            <v-col v-if="datos.ocupantesPas">
                                <DataTable :url="urlListado" :columns="columns" :params="displayInputs"
                                    :order="[[0, 'desc']]" @apiDT="apiDT = $event"></DataTable>

                            </v-col>


                        </v-col>
                        <v-col md="12" v-if="showFormOcPas">
                            <v-form ref="formOcupantesPas" v-model="validOcuPas" lazy-validation>
                                <span style="font-weight: bold;">Tipo:</span>
                                <v-radio-group v-model="datosOcPas.tipo" :rules="rules" row>
                                    <v-radio label="Ocupante" value="A"></v-radio>
                                    <v-radio label="Pasajero" value="B"></v-radio>
                                </v-radio-group>

                                <span style="font-weight: bold;">Nombre:</span>
                                <v-text-field v-model="datosOcPas.nombre"
                                    v-on:blur="datosOcPas.nombre = datosOcPas.nombre != null ? datosOcPas.nombre.trim() : null"
                                    outlined dense :rules="rulesInputsOcPas(5, 30)"></v-text-field>

                                <span style="font-weight: bold;">Teléfonos:</span>
                                <vue-tel-input-vuetify v-model="datosOcPas.numtelf" :error-messages="errorTelf"
                                    @input="onInput" outlined label="" autocomplete="off" loading="true" max="10"
                                    required placeholder="" :defaultCountry="pais" validCharactersOnly="false"
                                    v-on:country-changed="countryChanged" dense></vue-tel-input-vuetify>
                                <v-row>
                                    <v-col cols="6">
                                        <v-checkbox v-model="datosOcPas.lesiones" label="Lesiones" style="margin: 0px"
                                            hide-details></v-checkbox>
                                        <v-radio-group v-model="datosOcPas.lclave" v-if="datosOcPas.lesiones"
                                            :error-messages="errorLesiones" style="margin: -1px; margin-left: 15px;">
                                            <v-radio label="Ambulatorias" value="1"></v-radio>
                                            <v-radio label="Hospitalización" value="2"></v-radio>
                                        </v-radio-group>

                                    </v-col>
                                    <v-col cols="6">
                                        <v-checkbox v-model="datosOcPas.homicidios" label="Homicidio"
                                            style="margin: 0px" hide-details></v-checkbox>
                                    </v-col>
                                    <v-col cols="6">
                                        <div v-if="errorDelitos">
                                            <span class='spanError' style="color:red;font-size:12px">
                                                Indique una
                                                opción
                                            </span>
                                            <br />
                                        </div>
                                    </v-col>
                                </v-row>

                            </v-form>
                            <v-row justify="center">

                                <v-btn class="ma-2" color="primary" @click="guardarOcPas()"
                                    :disabled="disabledSaveOcPas">
                                    <span style='color: white;'>Guardar</span>
                                </v-btn>

                                <v-btn class="ma-2" color="#FF4081" @click="cancelarOcPas()"
                                    :disabled="disabledSaveOcPas">
                                    <span style='color: white;'>Cancelar</span>
                                </v-btn>
                            </v-row>

                        </v-col>


                        <v-col md="12" v-if="!disabledbutton && !showFormOcPas">
                            <v-row justify="center">

                                <v-btn class="ma-2" color="primary" @click="verFormulario()">
                                    <span style='color: white;'>Agregar</span>
                                </v-btn>
                            </v-row>
                        </v-col>


                    </v-card-text>

                </v-form>



            </v-card>
        </v-card>
    </v-flex>
</template>


<script>
import Reporte from "@/services/ExpJur/ExpJur.service.js";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";

export default {
    components: {
        DataTable
    },
    props: {
        validatermino: false,
        validaConclusion: false,
        svresponsabled: false
    },
    data: () => ({
        editPorque: true,
        editObs: true,
        editCond: true,
        conteoOcupantes: 0,
        disabledSaveOcPas: false,
        showFormOcPas: false,
        errorDelitos: false,
        errorLesiones: '',
        rules: [v => !!v || 'Seleccione alguna opción'],
        errorTelf: [],
        phone: {
            number: null,
            valid: false,
            country: null
        },
        prefijo: null,
        pais: 'MX',
        validOcuPas: true,
        datosOcPas: {
            tipo: null,
            nombre: null,
            numtelf: null,
            lesiones: false,
            lclave: null,
            homicidios: false

        },
        classAutoridad: 'disable-action',
        validForm: true,
        datos: {
            //Delitos
            Svdpa: false,
            Svlesiones: false,
            lclave: null,
            Svrobo: false,
            Svhomicidios: false,
            Svavgc: false,
            //Agravantes
            Svebriedad: false,
            Svfuga: false,
            Svdrogas: false,
            //Tipo Accidente
            Svcortedc: false,
            Svpreferenciadp: false,
            Svpasadada: false,
            pdaclave: null,
            pdatestigos: null,
            pdatestigosexterno: null,
            pdatestigosocupante: null,
            pdacamaras: null,
            pdacamarastransito: null,
            pdacamarasparticular: null,
            Svperdidadc: false,
            Svinvanciondc: false,
            Saincorp: false,
            Svalcancecp: false,
            Svalcances: false,
            Svalcancepa: false,
            Svmaniobrasdr: false,
            Svatropello: false,
            Svotrata: false,
            Svotrotaobs: null,
            //Responsabilidad por parte de
            Svresponsable: null,
            Svdetporque: null,
            //Datos proporcionados
            Svcondicionado: false,
            Svcondporque: null,
            Svmarca: null,
            Svcolor: null,
            Svlicencia: null,
            Svmodelo: null,
            Svplaca: null,
            //Monto de daños del vehículo asegurado:
            Svdeducible: 0,
            Svperdidatotal: 0,
            Svestdanosveh: 0,
            dacobertura: null,
            Svrevisapoliza: false,
            //Responsabilidad por parte del lider
            sacriteriolider: null,
            sadesclider: null,
            Paclave: null,
            //Datos de homicidio
            datHomicidios: false,
            dhnaocupante: false,
            dhnaocupantenum: 0,
            dh3conductor: false,
            dh3conductornum: 0,
            dh3ocupante: false,
            dh3ocupantenum: 0,
            dh3peaton: false,
            dh3peatonnum: 0,
            ocupantesPas: false,
            CopyocupantesPas: false,
            saautoridad: null,

        },
        datosCopy: {
            //Delitos
            Svdpa: false,
            Svlesiones: false,
            lclave: null,
            Svrobo: false,
            Svhomicidios: false,
            Svavgc: false,
            //Agravantes
            Svebriedad: false,
            Svfuga: false,
            Svdrogas: false,
            //Tipo Accidente
            Svcortedc: false,
            Svpreferenciadp: false,
            Svpasadada: false,
            pdaclave: null,
            pdatestigos: null,
            pdatestigosexterno: null,
            pdatestigosocupante: null,
            pdacamaras: null,
            pdacamarastransito: null,
            pdacamarasparticular: null,
            Svperdidadc: false,
            Svinvanciondc: false,
            Saincorp: false,
            Svalcancecp: false,
            Svalcances: false,
            Svalcancepa: false,
            Svmaniobrasdr: false,
            Svatropello: false,
            Svotrata: false,
            Svotrotaobs: null,
            //Responsabilidad por parte de
            Svresponsable: null,
            Svdetporque: null,
            //Datos proporcionados
            Svcondicionado: false,
            Svcondporque: null,
            Svmarca: null,
            Svcolor: null,
            Svlicencia: null,
            Svmodelo: null,
            Svplaca: null,
            //Monto de daños del vehículo asegurado:
            Svdeducible: 0,
            Svperdidatotal: 0,
            Svestdanosveh: 0,
            dacobertura: null,
            Svrevisapoliza: false,
            //Responsabilidad por parte del lider
            sacriteriolider: null,
            sadesclider: null,
            Paclave: null,
            //Datos de homicidio
            datHomicidios: false,
            dhnaocupante: false,
            dhnaocupantenum: 0,
            dh3conductor: false,
            dh3conductornum: 0,
            dh3ocupante: false,
            dh3ocupantenum: 0,
            dh3peaton: false,
            dh3peatonnum: 0,
            ocupantesPas: false,
            CopyocupantesPas: false,
            saautoridad: null,

        },
        validation: {
            errorDelitos: false,
            errorLesiones: '',
            errorCrucecon: false,
            errorTestigos: '',
            errorTestigosExtra: false,
            errorCamaras: '',
            errorCamarasExtra: false,
            errorEstDanos: '',
            errorResponsabilidad: '',
            errorLicencia: '',
            errorPlaca: '',
            errorPoliza: ''
        },
        disabledbutton: false,
        disabledSave: false,
        opcionesPasadaAlto: [],
        rulestextarea: [
            v => {
                if (v == null || v == '') {
                    return true
                }
                else {
                    //if (v.length < 12) {
                    //    return 'Mínimo 12 Carácteres'
                    //}
                    //else if (v.length > this.$store.state.maxLengthComentarios) {
                    //    return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres"
                    //}
                    //else
                    //    return true
                    if (v.length < 12) {
                        return 'Mínimo 12 Carácteres'
                    }
                    else if (v.length > 255) {
                        return "Máximo 255 Carácteres"
                    }
                    else
                        return true
                }
            },
        ],
        rulestextareaCond: [
            v => {
                if (v == null || v == '') {
                    return true
                }
                else {
                    //if (v.length < 12) {
                    //    return 'Mínimo 12 Carácteres'
                    //}
                    //else if (v.length > this.$store.state.maxLengthComentarios) {
                    //    return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres"
                    //}
                    //else
                    //    return true
                    if (v.length < 12) {
                        return 'Mínimo 12 Carácteres'
                    }
                    else if (v.length > 255) {
                        return "Máximo 255 Carácteres"
                    }
                    else
                        return true
                }
            },
        ],
        rulestextareaDet: [
            v => {
                if (v == null || v == '') {
                    return true
                }
                else {
                    //if (v.length < 12) {
                    //    return 'Mínimo 12 Carácteres'
                    //}
                    //else if (v.length > this.$store.state.maxLengthComentarios) {
                    //    return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres"
                    //}
                    //else
                    //    return true
                    if (v.length < 12) {
                        return 'Mínimo 12 Carácteres'
                    }
                    else if (v.length > 255) {
                        return "Máximo 255 Carácteres"
                    }
                    else
                        return true
                }
            },
        ],
        rulesInputsNumberDanios: [(v) => {
            if (v == null || v == '') {
                return 'Inserte un valor valido';
            }
            else {
                if (v < 0 || v > 5000000) {
                    return 'El monto debe ser entre 0 y 5 millones';
                }
                else
                    return new RegExp('^[0-9]+(\.[0-9]{1,2})?$').test(v) || "Inserte un valor valido"
            }
            return true
        }],
        rulestextareaOtro: [
            v => {
                if (v == null || v == '') {
                    return true
                }
                else {
                    //if (v.length < 12) {
                    //    return 'Mínimo 12 Carácteres'
                    //}
                    //else if (v.length > this.$store.state.maxLengthComentarios) {
                    //    return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres"
                    //}
                    //else
                    //    return true
                    if (v.length < 12) {
                        return 'Mínimo 12 Carácteres'
                    }
                    else if (v.length > 255) {
                        return "Máximo 255 Carácteres"
                    }
                    else
                        return true
                }
            },
        ],
        rulesInputsNumber: [(v) => {
            if (v == null || v == '') {
                return true;
            }
            else if (v.length > 10) {
                return 'Inserte un valor valido';
            }
            else {
                return new RegExp('^[0-9]+(\.[0-9]{1,2})?$').test(v) || "Inserte un valor valido"
            }
            return true
        }],
        opcionesCobertura: [
            {
                dacobertura: "Sin Cobertura",
                text: "Sin Cobertura"
            },
            {
                dacobertura: "Amplia",
                text: "Amplia"
            },
            {
                dacobertura: "Limitada",
                text: "Limitada"
            }
        ],
        urlListado: "ExpJur/ObtenerOcupantesP",
        columns: [
            { name: 'Nombre', data: 'Nombre', title: "Nombre" },
            { name: 'Telefono', data: 'Telefono', title: "Teléfono" },
            { name: 'Tipo', data: 'Tipo', title: "Tipo" },
            { name: 'Lesiones', data: 'Lesiones', title: "Lesión/Homicidio" },
            { name: 'TipoLesiones', data: 'TipoLesiones', title: "Tipo Lesión" }

        ],
        displayInputs: {
            nrreporte: 0,
            svindice: 0
        },
        editAsegurado: false,
        showbuttons: false,
        //edit: false,
        //classdisabled: ""
        edit: true,
        classdisabled: "disable-action"

        }),
    computed: {
        ...mapState(["domain", "informationPage"]),
        isAccidentSelected() {
            return (
                this.datos.Svcortedc ||
                this.datos.Svpreferenciadp ||
                this.datos.Svpasadada ||
                this.datos.Svperdidadc ||
                this.datos.Svinvanciondc ||
                this.datos.Saincorp ||
                this.datos.Svalcancecp ||
                this.datos.Svalcances ||
                this.datos.Svalcancepa ||
                this.datos.Svmaniobrasdr ||
                this.datos.Svatropello ||
                this.datos.Svotrata
            );
        },

    },
    watch: {
        async '$store.state.asegurado'(val) {
            if (val == 1) {


                const datosAsegurado = await Reporte.obtenerDatosAsegurado(this);

                this.datos.dh3conductornum = datosAsegurado[0].dh3conductornum;
                this.datos.dh3conductor = datosAsegurado[0].dh3conductor;
                this.datos.dh3ocupante = datosAsegurado[0].dh3ocupante;
                this.datos.dh3ocupantenum = datosAsegurado[0].dh3ocupantenum;
                this.datos.dh3peaton = datosAsegurado[0].dh3peaton;
                this.datos.dh3peatonnum = datosAsegurado[0].dh3peatonnum;
                this.datos.datHomicidios = datosAsegurado[0].datHomicidios;

                this.datosCopy.dh3conductornum = datosAsegurado[0].dh3conductornum;
                this.datosCopy.dh3conductor = datosAsegurado[0].dh3conductor;
                this.datosCopy.dh3ocupante = datosAsegurado[0].dh3ocupante;
                this.datosCopy.dh3ocupantenum = datosAsegurado[0].dh3ocupantenum;
                this.datosCopy.dh3peaton = datosAsegurado[0].dh3peaton;
                this.datosCopy.dh3peatonnum = datosAsegurado[0].dh3peatonnum;
                this.datosCopy.datHomicidios = datosAsegurado[0].datHomicidios;
            }

        },
        'datosOcPas.lesiones'(val) {
            if (!val) {
                this.datosOcPas.lclave = null;
                this.errorLesiones = "";
            }
            else {
                this.datosOcPas.homicidios = false;
                this.errorDelitos = false;
            }
        },
        'datosOcPas.homicidios'(val) {
            if (val) {
                this.datosOcPas.lesiones = false;
                this.errorDelitos = false;
            }
        },
        'datosOcPas.lclave'(val) {
            if (val != null) {
                this.errorLesiones = "";
            }
        },
        'datos.Svdpa'(val) {
            if (!val) {
                this.validation.errorEstDanos = "";
            }
            else {
                this.validation.errorDelitos = false;
            }
        },
        'datos.Svlesiones'(val) {
            if (!val) {
                this.datos.lclave == null;
                this.validation.errorLesiones = "";
            }
            else {
                this.validation.errorDelitos = false;
            }
        },
        'datos.Svrobo'(val) {
            if (val) {
                this.validation.errorDelitos = false;
            }
        },
        'datos.Svhomicidios'(val) {
            if (val) {
                this.validation.errorDelitos = false;
            }
        },
        'datos.Svavgc'(val) {
            if (val) {
                this.validation.errorDelitos = false;
            }
        },
        'datos.lclave'(val) {
            if (val != null) {
                this.validation.errorLesiones = "";
            }
        },
        'datos.Svpasadada'(val) {
            if (!val) {
                this.validation.errorCrucecon = false;
                this.validation.errorTestigos = "";
                this.validation.errorCamaras = "";
            }
        },
        'datos.pdaclave'(val) {
            if (val != null) {
                this.validation.errorCrucecon = false;
            }
        },
        'datos.pdatestigos'(val) {
            if (val != null) {
                this.validation.errorTestigos = "";
            }
            if (val != '1') {
                this.validation.errorTestigosExtra = false;
            }
        },
        'datos.pdacamaras'(val) {
            if (val != null) {
                this.validation.errorCamaras = "";
            }
            if (val != '1') {
                this.validation.errorCamarasExtra = false;
            }
        },

        'datos.pdatestigosocupante'(val) {
            if (val) {
                this.validation.errorTestigosExtra = false;
            }
        },
        'datos.pdatestigosexterno'(val) {
            if (val) {
                this.validation.errorTestigosExtra = false;
            }
        },

        'datos.pdacamarastransito'(val) {
            if (val) {
                this.validation.errorCamarasExtra = false;
            }
        },
        'datos.pdacamarasparticular'(val) {
            if (val) {
                this.validation.errorCamarasExtra = false;
            }
        },
        'datos.Svestdanosveh'(val) {
            if (val >= 1) {
                this.validation.errorEstDanos = "";
            }
        },
        'datos.Svresponsable'(val) {
            if (val != null) {
                this.validation.errorResponsabilidad = "";
            }
            if (val == 'ND') {
                if (!this.edit) {
                    this.editPorque = false;
                }
                this.rulestextareaDet = [];
                setTimeout(() => {
                    this.rulestextareaDet = [
                        v => {
                            if (v == null || v == '') {
                                return 'Indicar el tipo de responsabilidad correspondiente a la casilla'
                            }
                            else {
                                if (v.length < 12) {
                                    return 'Mínimo 12 Carácteres'
                                }
                                else if (v.length > 255) {
                                    return "Máximo 255 Carácteres"
                                }
                                else
                                    return true
                            }
                        }]
                }, 200);
            }
            else {
                this.editPorque = true;
                this.datos.Svdetporque = null;
                this.rulestextareaDet = [];
                setTimeout(() => {
                    this.rulestextareaDet = [
                        v => {
                            if (v == null || v == '') {
                                return true
                            }
                            else {
                                if (v.length < 12) {
                                    return 'Mínimo 12 Carácteres'
                                }
                                else if (v.length > 255) {
                                    return "Máximo 255 Carácteres"
                                }
                                else
                                    return true
                            }
                        }]
                }, 200);
            }
        },
        'datos.dacobertura'(val) {
            if (val != null) {
                this.validation.errorCobertura = false;
            }
        },
        'datos.Svcondicionado'(val) {
            if (val) {
                if (!this.edit) {
                    this.editCond = false;
                }
                this.rulestextareaCond = [];
                setTimeout(() => {
                    this.rulestextareaCond = [
                        v => {
                            if (v == null || v == '') {
                                return 'Indicar siniestro condicionado'
                            }
                            else {
                                if (v.length < 12) {
                                    return 'Mínimo 12 Carácteres'
                                }
                                else if (v.length > 255) {
                                    return "Máximo 255 Carácteres"
                                }
                                else
                                    return true
                            }
                        }]
                }, 200);
            }
            else {
                this.editCond = true;
                this.datos.Svcondporque = null;
                this.rulestextareaCond = [];
                setTimeout(() => {
                    this.rulestextareaCond = [
                        v => {
                            if (v == null || v == '') {
                                return true
                            }
                            else {
                                if (v.length < 12) {
                                    return 'Mínimo 12 Carácteres'
                                }
                                else if (v.length > 255) {
                                    return "Máximo 255 Carácteres"
                                }
                                else
                                    return true
                            }
                        }]
                }, 200);

            }
        },

        'datos.Svotrata'(val) {
            if (val) {
                if (!this.edit) {
                    this.editObs = false;
                }
                this.rulestextareaOtro = [];
                setTimeout(() => {
                    this.rulestextareaOtro = [
                        v => {
                            if (v == null || v == '') {
                                return 'Indicar el tipo de accidente correspondiente a la casilla otro'
                            }
                            else {
                                if (v.length < 12) {
                                    return 'Mínimo 12 Carácteres'
                                }
                                else if (v.length > 255) {
                                    return "Máximo 255 Carácteres"
                                }
                                else
                                    return true
                            }
                        }]
                }, 200);
            }
            else {
                this.datos.Svotrotaobs = null;
                this.editObs = true;
                this.rulestextareaOtro = [];
                setTimeout(() => {
                    this.rulestextareaOtro = [
                        v => {
                            if (v == null || v == '') {
                                return true
                            }
                            else {
                                // return 'Mínimo 12 Carácteres'

                                if (v.length < 12) {
                                    return 'Mínimo 12 Carácteres'
                                }
                                else if (v.length > 255) {
                                    return "Máximo 255 Carácteres"
                                }
                                else
                                    return true
                            }
                        }]
                }, 200);

            }
        },

        'datos.Svlicencia'(val) {
            if (val != null && val != '') {
                this.validation.errorLicencia = '';
            }
        },
        'datos.Svrevisapoliza'(val) {
            if (val) {
                this.validation.errorPoliza = '';
            }
        },
        'datos.Svplaca'(val) {
            if (val != null && val != '') {
                this.validation.errorPlaca = '';
            }
        },

    },
    methods: {
        verFormulario() {
            this.datos.ocupantesPas = false;
            this.showFormOcPas = true;

        },
        cancelarOcPas() {
            if (this.conteoOcupantes > 0 || this.datos.CopyocupantesPas) {
                this.datos.ocupantesPas = true;
            }
            this.phone = {
                number: null,
                valid: false,
                country: null
            };
            this.prefijo = null;
            this.pais = 'MX';
            this.validOcuPas = true;
            this.datosOcPas = {
                tipo: null,
                nombre: null,
                numtelf: null,
                lesiones: false,
                lclave: null,
                homicidios: false

            };
            this.errorDelitos = false;
            this.validOcuPas = true;

            setTimeout(() => {
                this.errorTelf = [];
            }, 100);
            this.showFormOcPas = false;
            this.$refs.formOcupantesPas.reset();
        },
        async guardarOcPas() {
            this.disabledSaveOcPas = true;
            this.$refs.formOcupantesPas.validate();
            let cont = 0;
            if (this.datosOcPas.numtelf != null && this.datosOcPas.numtelf != '') {
                if (!this.phone.valid) {
                    cont++;
                    this.errorTelf.push("Teléfono Inválido");
                }
            }

            if (!this.datosOcPas.lesiones && !this.datosOcPas.homicidios) {
                cont++;
                this.errorDelitos = true;
            }
            if (this.datosOcPas.lesiones && this.datosOcPas.lclave == null) {
                cont++;
                this.errorLesiones = "Indique una opción";
            }
            if (this.$refs.formOcupantesPas.validate() && cont == 0) {
                this.$swal({
                    position: 'center',
                    title: 'Guardando datos del Ocupante...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }


                });

                await Reporte.agregarOcupantes(this).then(response => {
                    setTimeout(() => {
                        this.$swal.close();
                        if (response) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se guardaron los datos correctamente',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    const datosAsegurado = await Reporte.obtenerDatosAsegurado(this);

                                    this.datos.dhnaocupante = datosAsegurado[0].dhnaocupante;
                                    this.datosCopy.dhnaocupante = datosAsegurado[0].dhnaocupante;

                                    this.datos.dhnaocupantenum = datosAsegurado[0].dhnaocupantenum;
                                    this.datosCopy.dhnaocupantenum = datosAsegurado[0].dhnaocupantenum;

                                    this.datos.datHomicidios = datosAsegurado[0].datHomicidios;
                                    this.datosCopy.datHomicidios = datosAsegurado[0].datHomicidios;


                                    this.datos.ocupantesPas = true;
                                    this.disabledSaveOcPas = false;
                                    this.cancelarOcPas();
                                    this.conteoOcupantes++;
                                    this.$emit("reload", true);

                                }
                            });
                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Error',
                                text: 'Hubo un error al guardar los datos del Ocupante, Favor de avisar a Desarrollo',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            })
                        }

                    }, 2000);

                });
            }
            else {
                this.disabledSaveOcPas = false;

            }
        },
        countryChanged(country) {
            this.prefijo = country.dialCode;
            this.pais = country.iso2;
        },
        onInput(formattedNumber, { number, valid, country }) {
            if (number.input == number.national) {
                this.errorTelf = [];
                this.phone.number = number.national;
                this.phone.valid = valid;
                this.phone.country = country && country.name;
            }
            else {
                if (this.datosOcPas.numtelf != null && this.datosOcPas.numtelf != '') {
                    this.errorTelf.push("Teléfono Inválido");
                    this.phone.number = number.national;
                    this.phone.valid = false;
                    this.phone.country = country && country.name;
                }
                else {
                    this.errorTelf = [];
                }

            }

        },
        editarAutoridad() {
            this.classAutoridad = '';
        },
        async guardarEdicion() {
            this.disabledSave = true;
            this.$refs.form.validate();
            if (this.validar() && this.$refs.form.validate()) {
                this.disabledSave = false;
                this.$swal({
                    position: 'center',
                    title: 'Guardando datos...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }


                });
                await Reporte.editarAsegurado(this).then(response => {

                    setTimeout(() => {
                        this.$swal.close();
                        if (response) {
                            for (var clave in this.datos) {
                                if (this.datosCopy.hasOwnProperty(clave)) {
                                    this.datosCopy[clave] = this.datos[clave];
                                }
                            }
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se guardaron los datos correctamente',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then(async (result) => {
                                if (result.isConfirmed) {

                                    const datosAsegurado = await Reporte.obtenerDatosAsegurado(this);

                                    this.datos.dhnaocupante = datosAsegurado[0].dhnaocupante;
                                    this.datosCopy.dhnaocupante = datosAsegurado[0].dhnaocupante;

                                    this.datos.dhnaocupantenum = datosAsegurado[0].dhnaocupantenum;
                                    this.datosCopy.dhnaocupantenum = datosAsegurado[0].dhnaocupantenum;

                                    this.datos.datHomicidios = datosAsegurado[0].datHomicidios;
                                    this.datosCopy.datHomicidios = datosAsegurado[0].datHomicidios;


                                    this.disabledSave = false;
                                    this.showbuttons = false;
                                    this.editAsegurado = false;
                                    this.edit = true;
                                    this.classdisabled = 'disable-action';
                                    this.editObs = true;
                                    this.editPorque = true;
                                    this.editCond = true;
                                    this.$emit("reload", true);

                                }
                            });

                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Error',
                                text: 'Hubo un error al guardar los datos, Favor de avisar a Desarrollo',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            })
                        }
                    }, 1000);

                });


            }
            else {
                this.disabledSave = false;
            }
        },

        async guardarAutoridad() {

            await Reporte.editarAutoridad(this).then(response => {

                setTimeout(() => {
                    this.$swal.close();
                    if (response) {


                        this.classAutoridad = "disable-action";

                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se guardaron los datos correctamente',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        });


                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'Error',
                            text: 'Hubo un error al guardar los datos, Favor de avisar a Desarrollo',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                    }
                }, 1000);

            });



        },
        async cancelarAutoridad() {

            this.datos.saautoridad = this.datosCopy.saautoridad;
            this.classAutoridad = "disable-action";

        },
        validar() {
            let conterror = 0;
            if (!this.datos.Svdpa && !this.datos.Svlesiones && !this.datos.Svrobo && !this.datos.Svhomicidios && !this.datos.Svavgc) {
                conterror++;
                this.validation.errorDelitos = true;
            }
            if (this.datos.Svlesiones && this.datos.lclave == null) {
                conterror++;
                this.validation.errorLesiones = "Indique una opción";
            }
            if (this.datos.Svpasadada) {
                if (this.datos.pdaclave == null) {
                    conterror++;
                    this.validation.errorCrucecon = true;
                }
                if (this.datos.pdatestigos == null) {
                    conterror++;
                    this.validation.errorTestigos = "Indique una opción";
                }
                if (this.datos.pdacamaras == null) {
                    conterror++;
                    this.validation.errorCamaras = "Indique una opción";
                }
                if (this.datos.pdatestigos == '1' && !this.datos.pdatestigosocupante && !this.datos.pdatestigosexterno) {
                    conterror++;
                    this.validation.errorTestigosExtra = true;
                }
                if (this.datos.pdacamaras == '1' && !this.datos.pdacamarastransito && !this.datos.pdacamarasparticular) {
                    conterror++;
                    this.validation.errorCamarasExtra = true;
                }
            }


            if (this.datos.Svdpa && (this.datos.Svestdanosveh == "0.00" || this.datos.Svestdanosveh == null || this.datos.Svestdanosveh == "" || this.datos.Svestdanosveh < 1)) {
                conterror++;
                this.validation.errorEstDanos = "Indique Monto Estimado de Daños";
            }
            if (this.datos.Svresponsable == null) {
                conterror++;
                this.validation.errorResponsabilidad = "Seleccione el tipo de responsablidad";
            }
            if (this.datos.dacobertura == null) {
                conterror++;
                this.validation.errorCobertura = true;
            }
            if (this.datos.Svlicencia == null || this.datos.Svlicencia == '') {
                conterror++;
                this.validation.errorLicencia = 'Campo requerido';
            }
            if (this.datos.Svplaca == null || this.datos.Svplaca == '') {
                conterror++;
                this.validation.errorPlaca = 'Campo requerido';
            }
            if (!this.datos.Svrevisapoliza) {
                conterror++;
                this.validation.errorPoliza = 'Favor de validar la póliza';
            }

            if (conterror > 0) {
                return false;
            }


            return true;

        },
        enabledForm() {
            this.showbuttons = true;
            this.editAsegurado = true;
            this.edit = false;
            this.classdisabled = '';

            if (this.datos.Svresponsable == 'ND') {
                this.editPorque = false;
            }
            if (this.datos.Svotrata) {
                this.editObs = false;
            }
            this.$refs.form.resetValidation();
        },
        cancelar() {
            for (var clave in this.datosCopy) {
                if (this.datos.hasOwnProperty(clave)) {
                    this.datos[clave] = this.datosCopy[clave];
                }
            }
            this.showbuttons = false;
            this.editAsegurado = false;
            this.edit = true;
            this.classdisabled = 'disable-action';
            this.editObs = true;
            this.editPorque = true;
            this.editCond = true;

            this.validation.errorDelitos = false;
            this.validation.errorLesiones = '';
            this.validation.errorCrucecon = false;
            this.validation.errorTestigos = '';
            this.validation.errorTestigosExtra = false;
            this.validation.errorCamaras = '';
            this.validation.errorCamarasExtra = false;
            this.validation.errorEstDanos = '';
            this.validation.errorResponsabilidad = '';
            this.validation.errorLicencia = '';
            this.validation.errorPlaca = '';
            this.validation.errorPoliza = '';

            this.$refs.form.resetValidation();

        },
        ruleMoney: function ($event, value) {

            if (value == '' || value == null) {
                if ($event.charCode >= 49 && $event.charCode <= 57) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }
            }
            else {
                if (($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode == 46) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }

            }
        },
        ruleMoneyDanios: function ($event, value) {

            if (value == '' || value == null) {
                if ($event.charCode >= 48 && $event.charCode <= 57) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }
            }
            else {
                if (($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode == 46) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }

            }
        },
        cambioPasada() {
            this.datos.pdaclave = null;
            this.datos.pdatestigos = null;
            this.datos.pdatestigosexterno = null;
            this.datos.pdatestigosocupante = null;
            this.datos.pdacamaras = null;
            this.datos.pdacamarastransito = null;
            this.datos.pdacamarasparticular = null;

        },
        cambioTestigos() {
            this.datos.pdatestigosexterno = null;
            this.datos.pdatestigosocupante = null;
        },
        cambioCamaras() {
            this.datos.pdacamarastransito = null;
            this.datos.pdacamarasparticular = null;
        },
        prueba() {
            console.log(this.datos);
        },
        rulesInputs(min, max) {
            var resultRules = [];
            resultRules.push((v) => {
                if (v == null) {
                    return true;
                } else {
                    if (v.trim().length < min) {
                        return "Mínimo " + min + " Carácteres";
                    } else if (v.trim().length > max) {
                        return "Máximo " + max + " Carácteres";
                    } else return true;
                }
            });
            return resultRules;
        },
        rulesInputsOcPas(min, max) {
            var resultRules = [];
            resultRules.push((v) => {
                if (v == null || v == '') {
                    return "Campo requerido";
                } else {
                    if (v.trim().length < min) {
                        return "Mínimo " + min + " Carácteres";
                    } else if (v.trim().length > max) {
                        return "Máximo " + max + " Carácteres";
                    } else return true;
                }
            });
            return resultRules;
        },
        uppercase(input) {
            if (input == "Svotrotaobs") {
                if (this.datos.Svotrotaobs != '' && this.datos.Svotrotaobs != null) {
                    this.datos.Svotrotaobs = this.datos.Svotrotaobs.toUpperCase();
                }
            }
            if (input == "Svdetporque") {
                if (this.datos.Svdetporque != '' && this.datos.Svdetporque != null) {
                    this.datos.Svdetporque = this.datos.Svdetporque.toUpperCase();
                }
            }
            if (input == "Svcondporque") {
                if (this.datos.Svcondporque != '' && this.datos.Svcondporque != null) {
                    this.datos.Svcondporque = this.datos.Svcondporque.toUpperCase();
                }
            }
            if (input == "sadesclider") {
                if (this.datos.sadesclider != '' && this.datos.sadesclider != null) {
                    this.datos.sadesclider = this.datos.sadesclider.toUpperCase();
                }
            }


        },
    },
    async mounted() {
        if (!this.validatermino || this.validaConclusion) { //si no tiene la fecha de termino o el permiso 160 o ya esta cerrado el reporte
            this.disabledbutton = true;
            this.disabledSave = true;
        }
        if (!this.svresponsabled && this.validatermino && !this.validaConclusion) { //si no tiene svresponsable y si tiene fecha de termino
            this.showbuttons = true;
            this.edit = false;
            this.classdisabled = '';
        }

        let datosreporte = await MetodosGenerales.obtenerSessionReporte('reporte');

        this.displayInputs = {
            nrreporte: datosreporte.nrreporte,
            svindice: datosreporte.svindice
        };

        const datosAsegurado = await Reporte.obtenerDatosAsegurado(this);
        Object.keys(datosAsegurado[0]).map(key => {
            if (typeof datosAsegurado[0][key] == "object") {
                if (this.datos.hasOwnProperty(key)) {
                    this.datos[key] = null;
                }
            } else {
                if (this.datos.hasOwnProperty(key)) {
                    this.datos[key] = datosAsegurado[0][key];
                }
            }
        })
        if (this.datos.Svpasadada) {
            this.datos.pdaclave = { pdaclave: datosAsegurado[0].pdaclave, pdamotivo: datosAsegurado[0].pdamotivo };
        }
        if (this.datos.dacobertura != null && this.datos.dacobertura != '') {
            this.datos.dacobertura = { dacobertura: datosAsegurado[0].dacobertura, text: datosAsegurado[0].dacobertura };
        }
        this.datos.Svdeducible = datosAsegurado[0].Svdeducible == 0 ? datosAsegurado[0].Svdeducible.toFixed(2) : datosAsegurado[0].Svdeducible;
        this.datos.Svperdidatotal = datosAsegurado[0].Svperdidatotal == 0 ? datosAsegurado[0].Svperdidatotal.toFixed(2) : datosAsegurado[0].Svperdidatotal;
        this.datos.Svestdanosveh = datosAsegurado[0].Svestdanosveh == 0 ? datosAsegurado[0].Svestdanosveh.toFixed(2) : datosAsegurado[0].Svestdanosveh;


        Object.keys(datosAsegurado[0]).map(key => {
            if (typeof datosAsegurado[0][key] == "object") {
                if (this.datosCopy.hasOwnProperty(key)) {
                    this.datosCopy[key] = null;
                }
            } else {
                if (this.datosCopy.hasOwnProperty(key)) {
                    this.datosCopy[key] = datosAsegurado[0][key];
                }
            }
        })
        if (this.datosCopy.Svpasadada) {
            this.datosCopy.pdaclave = { pdaclave: datosAsegurado[0].pdaclave, pdamotivo: datosAsegurado[0].pdamotivo };
        }
        if (this.datosCopy.dacobertura != null && this.datosCopy.dacobertura != '') {
            this.datosCopy.dacobertura = { dacobertura: datosAsegurado[0].dacobertura, text: datosAsegurado[0].dacobertura };
        }
        this.datosCopy.Svdeducible = datosAsegurado[0].Svdeducible == 0 ? datosAsegurado[0].Svdeducible.toFixed(2) : datosAsegurado[0].Svdeducible;
        this.datosCopy.Svperdidatotal = datosAsegurado[0].Svperdidatotal == 0 ? datosAsegurado[0].Svperdidatotal.toFixed(2) : datosAsegurado[0].Svperdidatotal;
        this.datosCopy.Svestdanosveh = datosAsegurado[0].Svestdanosveh == 0 ? datosAsegurado[0].Svestdanosveh.toFixed(2) : datosAsegurado[0].Svestdanosveh;


        Reporte.obtenerPasadaAlto(this);



    }
}

</script>